<template>
<div class="chapter">
<div class="inner_page">
<p class="FM-Epigraph-non-verse-fmepi__TOP"><span epub:type="pagebreak" id="pg_vii" title="vii">It is reported that Caesar, when he first heard Brutus speak in public, said to his friends, “I know not what this young man intends, but, whatever he intends, he intends it vehemently.”</span></p>
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-SC">PLUTARCH’S</span> <span class="ePub-I">Lives</span></p>
<p class="FM-Epigraph-non-verse-fmepi">He was one of those ideal Russian beings who can suddenly be so struck by some strong idea that it seems to crush them then and there, sometimes even forever.</p>
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-SC">DOSTOEVSKY,</span> <span class="ePub-I">Demons</span></p>
<p class="FM-Epigraph-non-verse-fmepi">Let the age and wars of other nations be chanted and their eras and characters be illustrated and that finish the verse. Not so the great psalm of the republic. Here the theme is creative and has vista. Here comes one among the wellbeloved stonecutters and plans with decision and science and sees the solid and beautiful forms of the future where there are now no solid forms.</p>
<p class="FM-Epigraph-Source-fmeps">—<span class="ePub-SC">WALT WHITMAN, 1855 PREFACE TO</span> <span class="ePub-I">Leaves of Grass</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?307d52ab